/**
 * Minimal toast system for admin. Uses a small pub/sub — no dep on shadcn/sonner.
 */
import { useEffect, useState } from "react";
import { CheckCircle2, XCircle } from "lucide-react";

let _push = null;

export function toast(kind, message) {
  if (_push) _push({ kind, message });
}

export default function ToastHost() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    _push = (t) => {
      const id = Math.random().toString(36).slice(2);
      setItems((all) => [...all, { id, ...t }]);
      setTimeout(() => setItems((all) => all.filter((x) => x.id !== id)), 3800);
    };
    return () => {
      _push = null;
    };
  }, []);
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-2 pointer-events-none" data-testid="admin-toast-host">
      {items.map((t) => (
        <div
          key={t.id}
          data-testid={`admin-toast-${t.kind}`}
          className={`pointer-events-auto rounded-md px-4 py-3 shadow-lg border flex items-center gap-3 min-w-[260px] max-w-md ${
            t.kind === "success"
              ? "bg-emerald-50 border-emerald-300 text-emerald-900"
              : "bg-red-50 border-red-300 text-red-900"
          }`}
        >
          {t.kind === "success" ? (
            <CheckCircle2 className="h-4 w-4 shrink-0" />
          ) : (
            <XCircle className="h-4 w-4 shrink-0" />
          )}
          <span className="text-sm">{t.message}</span>
        </div>
      ))}
    </div>
  );
}
